(function () {
  'use strict';

  let angular = window.angular;

  CCTVRouter.$inject = ['$stateProvider'];

  angular.module('app').config(CCTVRouter);

  function CCTVRouter($stateProvider) {
    $stateProvider
      .state('member.project.cctv', {
        url: '/cctv',
        redirectTo: 'member.project.cctv.home',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'CCTV',
        },
        resolve: {
          hasTool: [
            'tools',
            'AppUtils',
            function (tools, utils) {
              const hasTool = tools.find((tool) => tool.module === 'xompassCCTV');
              if (!hasTool) {
                throw utils.getHTTPError(new Error('Not allowed'), {
                  redirectTo: 'member.customer.invalidTool',
                  params: { tool: 'xompassCCTV' },
                });
              }
            },
          ],
          dependencies: [
            '$rootScope',
            '$ocLazyLoad',
            ($root, $ocLazyLoad) => {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/app/dashboard-common.module.min.js',
                window.assetsPath + '/js/app/cctv.module.min.js',
                window.assetsPath + `/css/cctv.style-${style}.css`,
              ]);
            },
          ],
        },
      })
      .state('member.project.cctv.home', {
        url: '/',
        component: 'cctvDashboardHome',
        resolve: {
          dashboards: [
            'EntityService',
            '$transition$',
            '$rootScope',
            function (EntityService, $transition$, $root) {
              const options = { id: $root.customerId, nk: $root.projectId };
              return EntityService.find('CctvDashboard', options);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"general.gallery" | translate}}',
        },
      })
      .state('member.project.cctv.show', {
        url: '/:dashboardId',
        component: 'cctvDashboardShow',
        redirectTo: 'member.project.cctv.show.cameras',
        authenticated: true,
        resolve: {
          dashboard: [
            'EntityService',
            '$transition$',
            '$rootScope',
            'AppUtils',
            function (EntityService, $transition$, $root, utils) {
              const options = {
                id: $root.customerId,
                nk: $root.projectId,
                dashboardId: $transition$.params().dashboardId,
              };
              return loadCCTVDashboard(EntityService, options, utils);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{$resolve.dashboard.name}}',
        },
      })
      .state('member.project.cctv.show.cameras', {
        url: '/?monitorId',
        component: 'cctvDashboardCameras',
        authenticated: true,
        ncyBreadcrumb: {
          label: "{{'general.cameraPl' | translate}}",
        },
      })
      .state('member.project.cctv.show.editor', {
        url: '/editor',
        component: 'cctvDashboardEditor',
        authenticated: true,
        ncyBreadcrumb: {
          label: '{{"views.tools.CctvDashboard.breadcrumb.editor" | translate}}',
        },
      });

    function loadCCTVDashboard(EntityService, params, utils) {
      const options = angular.copy(params);
      options.entityId = options.dashboardId;
      options.filter = {
        include: [
          'managers',
          {
            relation: 'assets',
            scope: { fields: ['id', 'name', 'type'], include: ['credentials'] },
          },
        ],
      };

      return EntityService.findById('CctvDashboard', options).catch((err) => {
        console.log(err);
        throw utils.getHTTPError(err, {
          redirectTo: 'member.project.cctv',
          params: { customerId: params.customerId, projectId: params.projectId },
        });
      });
    }
  }
})();
